import { PAGE_RESOLVERS, PageBuilderResolver, PageNotFoundResolver } from '@scalefast/ecommerce-core';
import { PageContentfulResolver } from '../pages/page/resolver/page-contentful-resolver';

/**
 * This provides a list of the page resolvers used in the store.
 * We use this factory function with the PAGE_RESOLVERS injection token key.
 * In this way the services will be available to be used for resolving pages.
 */
export function providePageResolver() {
  return {
    provide: PAGE_RESOLVERS,
    useFactory: (
      pageBuilderResolver: PageBuilderResolver,
      pageContentfulResolver: PageContentfulResolver,
      pageNotFoundResolver: PageNotFoundResolver,
    ) => {
      return [pageBuilderResolver, pageContentfulResolver, pageNotFoundResolver];
    },
    deps: [PageBuilderResolver, PageContentfulResolver, PageNotFoundResolver],
  };
}
